var map = {
	"./Instagram_logo_2022.svg": 5,
	"./Kuantum1.jpg": 5254,
	"./Kuantum1.pdf": 375,
	"./Kuantum2.jpg": 4833,
	"./Kuantum2.pdf": 5312,
	"./Kuantum3.jpg": 6788,
	"./Kuantum3.pdf": 3157,
	"./Kuantum4.jpg": 1103,
	"./Kuantum4.pdf": 3990,
	"./Kuantum5.jpg": 3170,
	"./Kuantum5.pdf": 2307,
	"./MASHT_logo.jpg": 5125,
	"./facebook-logo.png": 4382,
	"./grupi.jpg": 7255,
	"./konkursi/Konkurs për fotografin.jpg": 9484,
	"./kosovo.jpg": 6469,
	"./kursi24/1.jpg": 8290,
	"./kursi24/2.jpg": 1197,
	"./kursi24/3.jpg": 6624,
	"./kursi_fizike_foto/kursiifizikes1.jpg": 6650,
	"./kursi_fizike_foto/kursiifizikes2.jpg": 4501,
	"./kursi_fizike_foto/kursiifizikes3.jpg": 6888,
	"./kursi_fizike_foto/kursiifizikes4.jpg": 8475,
	"./logo.png": 3153,
	"./logowhite.png": 7834,
	"./main/1.jpg": 4403,
	"./main/1.png": 6731,
	"./main/2.jpg": 8340,
	"./main/3.jpg": 145,
	"./main/4.jpg": 4914,
	"./main/5.jpg": 2975,
	"./main/6.jpg": 9248,
	"./main/7.jpg": 4141,
	"./shperblimet2024/1.jpg": 2311,
	"./shperblimet2024/2.jpg": 9464,
	"./shperblimet2024/3.jpg": 645,
	"./shperblimet2024/4.jpg": 7230,
	"./shperblimet2024/5.jpg": 3067,
	"./shperblimet2024/6.jpg": 7900,
	"./shperblimet2024/7.jpg": 5897,
	"./videoSHFK.mp4": 5027
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;